<template>
	<div>
		<div v-if="$store.service.archived == 1" class="alert alert-warning job-status-alert">
			<i class="fa fa-archive"></i>
			This service is archived. In order to make changes you need to un-archive it.
		</div>
		<div v-else-if="!dateIsEmpty($store.service.completed)" class="alert alert-success job-status-alert">
			<i class="fa fa-check-square"></i>
			This service was completed on {{$store.service.completed}}.
		</div>
	</div>
</template>

<script type="text/javascript">
export default {
	name: "ArchivedAlert"
}
</script>